var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "24px",
    y: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1,12l3.7-3.7c0.3-0.3,0.3-0.8,0-1.1s-0.8-0.3-1.1,0L12,10.9L8.3,7.2C8,6.9,7.5,6.9,7.2,7.2S6.9,8,7.2,8.3 l3.7,3.7l-3.7,3.7c-0.3,0.3-0.3,0.8,0,1.1s0.8,0.3,1.1,0l3.7-3.7l3.7,3.7c0.3,0.3,0.8,0.3,1.1,0s0.3-0.8,0-1.1L13.1,12z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxCloseIcon);
export default __webpack_public_path__ + "static/media/vuesax-close-icon.abb5c1c5c3ba2e3910eab3da7e1b6f7b.svg";
export { ForwardRef as ReactComponent };